"use client"

import { LocateOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LocateOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LocateOffIcon = component(Icon)({ as: LocateOff })
